export default "__VITE_ASSET__ae28ba06__"